import { Map } from 'immutable';

import {
  CREATE_RELAY,
  DELETE_RELAY,
  EDIT_RELAY,
  PAIR_RELAYS,
  RECEIVE_RELAYS,
  REQUEST_SITE_GROUP_RELAYS,
  REQUEST_SITE_RELAYS,
  SYNC_RELAYS_FOR_CONTROLLER,
  UNPAIR_RELAYS,
} from '@sophocles/entities/Relay/relayActions';

function getState(state, action) {
  switch (action.type) {
    case RECEIVE_RELAYS:
      return action.relays;
    case DELETE_RELAY: // Delete
      return state.delete(action.relay.toString());
    case REQUEST_SITE_GROUP_RELAYS:
    case REQUEST_SITE_RELAYS:
    case EDIT_RELAY:
    case PAIR_RELAYS:
    case UNPAIR_RELAYS:
    case CREATE_RELAY:
    default:
      return state;
  }
}

export function relayReducer(state = Map(), action) {
  switch (action.type) {
    case SYNC_RELAYS_FOR_CONTROLLER: {
      const cid = String(action.controllerId);
      const pruned = state.filter(relay => String(relay.get('relay_controller')) !== cid);
      return pruned.merge(action.relays);
    }
    case REQUEST_SITE_RELAYS:
    case REQUEST_SITE_GROUP_RELAYS:
    case EDIT_RELAY:
    case RECEIVE_RELAYS:
    case PAIR_RELAYS:
    case UNPAIR_RELAYS:
    case DELETE_RELAY:
    case CREATE_RELAY:
      return state.merge(getState(state, action));
    default:
      return state;
  }
}
